/**
 * Handles things related to form elements in general.
 */

// Toggle select2 on elements which we want to have a select2 dropdown.
jQuery( $ => {
	$( '.enhanced-select' ).select2();

	$( '.toggle-element' ).on( 'click', function() {
		const target = $( this ).data( 'for' );
		$( this ).siblings( '#' + target ).toggle().focus();
	} );

	$( '#select-school-year' ).on( 'change', function() {
		$( this ).closest( 'form' ).submit();
	} );

	// Confirm deletion
	$( '.button--delete' ).on( 'click', function( event ) {
		const confirmationMessage = $( this ).data( 'confirm' );
		if ( ! window.confirm( confirmationMessage ) ) { // eslint-disable-line no-alert
			event.preventDefault();
		}
	} );

	// Confirm copy of programs and call on AJAX function to create programs
	// Not translatable
	$( '.button--copy' ).on( 'click', function( event ) {
		const buttonElement = $( this );
		// Reload if copy is success and current year is present page.
		// Class is added after successful copy of programs
		if ( buttonElement.hasClass( 'reload-current' ) ) {
			event.preventDefault();
			window.location.reload();
			return true;
		}

		// Reload page with active year
		// Class is added after successful copy of programs
		if ( buttonElement.hasClass( 'reload-change' ) ) {
			event.preventDefault();
			const schoolId = buttonElement.attr( 'school_id' );
			const schoolYear = buttonElement.attr( 'school_year_id_from' );

			window.location.assign( `${ window.location.origin }${ window.location.pathname }?school-id=${ schoolId }&school-year-id=${ schoolYear }` );
			return true;
		}

		let textMessage = 'föregående års program';
		if ( buttonElement.hasClass( 'copy-from' ) ) {
			textMessage = 'program till nästa år';
		}

		if ( ! window.confirm( `Bekräfta kopiering av ${ textMessage }` ) ) { // eslint-disable-line no-alert
			event.preventDefault();
			return null;
		}

		event.preventDefault();
		buttonElement.attr( 'disabled', true );
		buttonElement.text( 'Vänligen vänta, stäng ej fönstret...' );

		// Get variables for AJAX
		let copyToSchoolYear = buttonElement.attr( 'school_year_id_from' );
		let currentSchoolYear = buttonElement.attr( 'school_year_id_to' );
		const schoolId = buttonElement.attr( 'school_id' );
		const nonceId = buttonElement.attr( 'nonce' );

		// Switch variables if you are on the previous year
		if ( buttonElement.hasClass( 'copy-from' ) ) {
			copyToSchoolYear = buttonElement.attr( 'school_year_id_to' );
			currentSchoolYear = buttonElement.attr( 'school_year_id_from' );
		}

		const data = {
			action: 'trigger_copy_programs',
			school_id: schoolId,
			school_year: copyToSchoolYear,
			current_school_year: currentSchoolYear,
			nonce: nonceId,
		};
		$.post( SkanegyScript.ajaxUrl, data, response => {
			const result = JSON.parse( response );
			let buttonText = 'Kopiering klar, laddar om sidan';

			// Logic to set the button to reload to the right page and display correct text
			if ( buttonElement.hasClass( 'copy-to' ) ) {
				buttonElement.addClass( 'reload-current' );
			} else {
				buttonElement.addClass( 'reload-change' );
			}

			if ( result.internal_status === 'no_posts_to_copy' ) {
				buttonText = 'Det finns inga program att kopiera, laddar om sidan';
			}

			if ( result.internal_status === 'no_new_posts' ) {
				buttonText = 'Inga nya program att kopiera, laddar om sidan';
			}
			buttonElement.text( buttonText );

			// To make it visually better and give the user a change to read
			setTimeout( () => {
				buttonElement.attr( 'disabled', false );
				event.preventDefault();
				window.location.reload();
			}, 500 );
		} );
	} );

	/**
	 * Restrict number field to max 5 characters and no special symbols or characters.
	 *
	 * @param {*} element
	 */
	function limitPostnr( element ) {
		element.val( element.val().replace( /[^0-9.]/g, '' ) );
		const charLength = element.val().length;
		if ( charLength > 5 ) {
			element.val( element.val().substring( 0, 5 ) );
		}
	}

	// Target the main postnr school info section
	$( 'body' ).on( 'keyup', 'div[data-name="skola_postnr"] .acf-input-wrap input[type="number"]', function() {
		limitPostnr( $( this ) );
	} );

	// Target the additional postnr school info section
	$( 'body' ).on( 'keyup', 'div[data-name="additional_skola_postnr"] .acf-input-wrap input[type="number"]', function() {
		limitPostnr( $( this ) );
	} );

	// Target the open houses address postnr section
	$( 'body' ).on( 'keyup', 'div[data-name="zip"] .acf-input-wrap input[type="number"]', function() {
		limitPostnr( $( this ) );
	} );
} );
